import { createRefPath_client, createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { useCallback, useContext } from 'react';
import { DatabaseContext } from '../DatabaseContext';

export const useGetData = () => {

  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  const getEventData = useCallback(({ pathViews, items, wheres, callback }) => {
    if (_.isEmpty(pathViews) || _.isEmpty(items) || !pathViews?.events) return;
    const _refPath = createRefPath_event(pathViews, items)
    database_fns.get_data({ refPath: _refPath, wheres, callback, opts: { listen: true } })
  }, []
  );

  const getClientData = useCallback(({ pathViews, items, wheres, callback }) => {
    if (_.isEmpty(pathViews) || _.isEmpty(items) || !pathViews?.clients) return;
    const _refPath = createRefPath_client(pathViews, items)
    database_fns.get_data({ refPath: _refPath, wheres, callback, opts: { listen: true } })
  }, []
  );

  return { getEventData, getClientData }

}
